module.exports = __webpack_public_path__ + "fonts/InstagramSans-Medium.bc97f279.woff";